<template>
  <!-- <pre v-if="responseData"> testData={{ responseData }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/HAIWAN TERBIAR.png"
        alt="HAIWAN TERBIAR"
        class="pbt-image"
      >
      <!-- Center the line under the image -->
      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <h2>PROGRAM KAWALAN HAIWAN TERBIAR</h2>
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedMonth"
            label="Bulan"
            :items="months"
            placeholder="Pilih Bulan"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
            @update:model-value="handleStateChange"
          />
        </div>
      </div>

      <h2>AKTIVITI KAWALAN ANJING TERBIAR</h2>
      <div class="haiwan">
        <div
          v-for="(haiwan, index) in haiwanData"
          :key="index"
          class="haiwan-container"
        >
          <img
            src="@/assets/spah/box.png"
            :alt="haiwan.altText"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>{{ haiwan.title }}</h3>
              <p class="number">
                {{ numberWithCommas(haiwan.count) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PrimaryModule />
    <KesihatanPersekitaran />
  </adminbackground>
</template>


<script setup>
import KesihatanPersekitaran from '@/components/menu-items/section-menu/kesihatan-persekitaran-menu.vue'
import { useHttpService } from "@/httpService"
import { computed, onMounted, ref } from 'vue'

const years = ref([])

const months = ref([
  "Semua Bulan",  
  "Januari",
  "Februari",
  "Mac",
  "April",
  "Mei",
  "Jun", 
  "Julai",
  "Ogos",
  "September",
  "Oktober",
  "November",
  "Disember",
])


const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])
const selectedYear = ref(2025)

// const selectedMonth = ref('Januari') 

const selectedMonth = ref('Semua Bulan') 
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')

//added by abdullah 
definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const anjing = ref({ 
  bilanganAduan: 0,
  bilanganOperasi: 0,
  bilanganKesGigitanDilaporkan: 0,
  bilanganDitangkap: 0,
  bilanganDituntut: 0,
  programAnjingAngkat: 0,
  bilanganPelupusan: 0,
  bilanganAnjingVet: 0,
  bilanganAnjingNgo: 0,
})

const haiwanData = computed(() => [
  { title: 'Bilangan Aduan', count: anjing.value.bilanganAduan, altText: 'First Image' },
  { title: 'Bilangan Operasi (Kumulatif)', count: anjing.value.bilanganOperasi, altText: 'Second Image' },
  { title: 'Bilangan Kes Gigitan Dilaporkan (Kumulatif)', count: anjing.value.bilanganKesGigitanDilaporkan, altText: 'Third Image' },
  { title: 'Bilangan Anjing Ditangkap', count: anjing.value.bilanganDitangkap, altText: 'Third Image' },
  { title: 'Bilangan Dituntut', count: anjing.value.bilanganDituntut, altText: 'Third Image' },
  { title: 'Program Anjing Angkat (Kumulatif)', count: anjing.value.programAnjingAngkat, altText: 'Third Image' },
  { title: 'Bilangan Pelupusan', count: anjing.value.bilanganPelupusan, altText: 'Third Image' },
  { title: 'Bilangan Anjing Dihantar ke NGO', count: anjing.value.bilanganAnjingNgo, altText: 'Third Image' },
  { title: 'Bilangan Anjing Dihantar ke Veteriner', count: anjing.value.bilanganAnjingVet, altText: 'Third Image' },
])

const { httpGet, numberWithCommas } = useHttpService()

const responseData = ref(null)


async function loadDataFromApi(month = selectedMonth.value, year = selectedYear.value, state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {
    const plainStates = toRaw(state)
    let queryParams = `year=${year}`
    if (month === "Semua Bulan") {
      queryParams += `&month=all`
    } else {
      queryParams += `&month=${months.value.indexOf(month)}`
    }
    if (!plainStates.includes("Semua Negeri")) {
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }
    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }

    // const url = `kesihatan-persekitaran/haiwan-terbiar?year=${selectedYear.value}&month=${selectedMonth.value}${queryParams}`
    
    const url = `kesihatan-persekitaran/haiwan-terbiar?${queryParams}`
    const response = await httpGet(url)


    years.value = response.years
    states.value = ["Semua Negeri"]
    response.states.forEach(state => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state)
      }
    })

    councils.value = response.councils
    responseData.value = response
    var data=responseData.value.data.data

    anjing.value = { 
      bilanganAduan: data.bilangan_aduan_anjing,
      bilanganOperasi: data.bilangan_operasi,
      bilanganKesGigitanDilaporkan: data.bilangan_program_anjing_angkat,
      bilanganDitangkap: data.bilangan_tangkapan_anjing,
      bilanganDituntut: data.bilangan_anjing_vet,
      programAnjingAngkat: data.bilangan_anjing_dituntut,
      bilanganPelupusan: data.bilangan_pelupusan_anjing,
      bilanganAnjingVet: data.bilangan_anjing_ngo,
      bilanganAnjingNgo: data.bilangan_anjing_ngo,
    }
  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}

function handleStateChange() {
  pbt.value = []
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : []
  }
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter(pbt => pbt !== "Semua PBT")
  }
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }
  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"]
  }
  if (selectedsState.value.includes("Semua Negeri")) {
    Object.keys(councils.value).forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  } else {
    selectedsState.value.forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  }

}

onMounted(() => {
  loadDataFromApi()
  
})

watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })


watch([selectedMonth, selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApi(selectedMonth.value, selectedYear.value, selectedsState.value, selectedPbt.value)
}, { immediate: true })
</script>


<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); /* Background for content */
  border-radius: 20px; /* Rounded corners */
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); /* Shadow for depth */
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%; 
  height: auto;
}

.line-under-image {
  width: 70%; 
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

h2 {
  color: rgb(21,0,105);
  font-size: 1.5rem; 
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px; 
  text-align: left; 
  width: 100%;
}



.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}


.input-item {
  flex: 1;
  margin-right: 15px;
}


.input-item:last-child {
  margin-right: 0;
}


.haiwan {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 columns */
  grid-gap: 10px; /* Gap between the rows and columns */
}

.haiwan-container {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}


.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: Arial, sans-serif;
  text-align: center; /* Centers the text horizontally */
}

.values-layered h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #150069;
  text-align: center;
}

.number {
  font-size: 24px;
  font-weight: bold;
  color: #a80000;
  text-align: center;
}

@media (max-width: 1024px) {
  .content-wrapper {
    padding: 15px;
  }

  h2 {
    font-size: 1.4rem;
  }

  .haiwan {
    grid-template-columns: repeat(2, 1fr); /* 2 columns */
  }

  .values-layered h3 {
    font-size: 14px;
  }

  .number {
    font-size: 22px;
  }
}

/* For screens up to 768px */
@media (max-width: 768px) {
  .content-wrapper {
    padding: 15px;
  }

  h2 {
    font-size: 1.3rem;
  }

  .haiwan {
    grid-template-columns: 1fr; /* Single column */
  }

  .values-layered h3 {
    font-size: 20px;
  }

  .number {
    font-size: 20px;
  }
}

/* For screens up to 480px */
@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
  }

  h2 {
    font-size: 1.2rem;
  }

  .haiwan {
    grid-template-columns: 1fr; /* Single column */
    grid-gap: 15px;
  }

  .haiwan-container {
    padding: 10px;
    border-radius: 8px;
    margin-bottom: 10px;
  }

  .values-layered h3 {
    font-size: 1rem;
    margin-bottom: 5px;
  }

  .number {
    font-size: 1.5rem;
    color: #a80000;
  }
}
</style>
